
import {SensorChart} from '../sensor-chart/SensorChart';
import * as moment from 'moment';
import * as JQuery from 'jquery';

export class SlideChart extends SensorChart {

	protected animationFrame;
	protected isRunning;
	public fps = 60;
	public offset = 0;

	public constructor(element: string | Element | JQuery) {
		super(element);
	}

	protected getNow(): number {
		return moment().toDate().getTime() + this.offset;
	}

	public start() {
		this.isRunning = true;
		this.update();
	}

	public stop() {
		this.isRunning = false;
		if (this.animationFrame) {
			cancelAnimationFrame(this.animationFrame);
		}
	}

	protected update = () => {
		setTimeout(() => {
			if (this.isRunning) {
				this.setEndTime(this.getNow());
				this.redraw();
				this.animationFrame = requestAnimationFrame(this.update);
			}
		}, 1000 / this.fps);
	}

	public redraw() {
		if (this.context.container.is(':visible')) {
			super.redraw();
		}
	}

	public destroy() {
		super.destroy();
		this.stop();
	}

}

